export default "__VITE_ASSET__B1i7CmAJ__"